import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { ResellerService } from '@services/reseller.service';
import { SmsService } from '@services/sms.service';
import { SuperAccountSettings } from '@models/superaccount/settings';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { CNameConfiguration } from '@models/email/emailDomain';

import { EmailInternalService } from '@services/email-internal.service';
import { AtlasToastService } from '@services/atlas-toast.service';
import { LoaderService } from '@services/loader.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'wsb-superaccount-settings',
  templateUrl: './superaccount-settings.component.html',
  styleUrls: ['./superaccount-settings.component.scss'],
  standalone: false
})
export class SuperaccountSettingsComponent implements OnInit, AfterViewChecked {
  @ViewChild('modalCNameDetails') modalCNameDetails;
  @ViewChild('page') $page;
  @ViewChild('actionsBar') $actionsBar;
  modalCNameDetailsModal: NgbModalRef;

  faEllipsisH = faEllipsisH;
  settingsForm: UntypedFormGroup = null;
  msgTypes = [];
  superAccountSettings: SuperAccountSettings;
  cloneForm: SuperAccountSettings;
  profiles: any;
  removeExistingLogo = false;
  useDomainForAutoEmail: UntypedFormControl = new UntypedFormControl(false);
  domainForAutoEmail: CNameConfiguration;
  configurations;
  items;
  setDomainForAutoEmail = false;
  showDomainForAutoEmail = false;
  constructor(
    private resellerService: ResellerService,
    private formBuilder: UntypedFormBuilder,
    private atlasToast: AtlasToastService,
    private smsService: SmsService,
    private elRef: ElementRef,
    private loaderService: LoaderService,
    private emailInternalService: EmailInternalService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    window.addEventListener('scroll', this.scroll, true);

    this.settingsForm = this.formBuilder.group({
      domain: [''],
      buttonColor: [''],
      disablePasswordChange: [],
      headerColor: [''],
      shopEnabled: [],
      shopUrl: [''],
      logoBase64: [''],
      showSubSettings: [],
      titleColor: [''],
      messageTypeLabels: this.formBuilder.array([])
    });

    this.loaderService.show();
    this.resellerService
      .getProfiles()
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe(data => {
        this.profiles = data.data;
      });

    this.loaderService.show();
    this.resellerService
      .getSuperAccountSettings()
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe(data => {
        this.superAccountSettings = data;
        this.superAccountSettings.messageTypeLabels.map(x => {
          this.mountMsgType(x);
        });
        this.settingsForm.patchValue(this.superAccountSettings);
        this.initDomainCheck();

        this.smsService.getMessageTypes().subscribe(dataMsgTypeslabel => {
          dataMsgTypeslabel.data.map(x => {
            this.mountMsgType(x);
          });
        });
      });

    this.buildItems();

    this.cloneFormOnChange();
  }

  ngAfterViewChecked(): void {
    this.displayScrollIndicator();
  }

  scroll = (): void => {
    this.displayScrollIndicator();
  };

  cloneFormOnChange() {
    this.settingsForm.valueChanges.subscribe(val => {
      this.cloneForm = val;
    });
  }

  buildItems() {
    this.items = [
      {
        onClick: e => this.openModalCNameDetails(),
        label: 'emaildns_view_config'
      },
      {
        onClick: e => this.verifyDomain(),
        label: 'emaildns_verify'
      }
    ];
  }

  dropdownClick() {}

  verifyDomain() {
    this.emailInternalService.verifyInternaEmailDomain(this.domainForAutoEmail.id).subscribe(
      configuration => {
        this.atlasToast.success('common_success', null);

        this.domainForAutoEmail.valid = configuration.valid;
        this.domainForAutoEmail.dns.dkim1.valid = configuration.dns.dkim1.valid;
        this.domainForAutoEmail.dns.dkim2.valid = configuration.dns.dkim2.valid;
        this.domainForAutoEmail.dns.mailCname.valid = configuration.dns.mailCname.valid;
        this.domainForAutoEmail.dns.mailServer.valid = configuration.dns.mailServer.valid;
        this.domainForAutoEmail.dns.spf.valid = configuration.dns.spf.valid;
      },
      error => this.atlasToast.error('common_error', null)
    );
  }

  initDomainCheck() {
    if (!this.settingsForm.get('domain').value) {
      return;
    }

    this.emailInternalService.getInternalEmailDomainConfig().subscribe(configurations => {
      this.configurations = configurations.data;
      if (!this.configurations.find(c => c.domain === this.settingsForm.get('domain').value)) {
        this.useDomainForAutoEmailValueChanges();
        return;
      }
      this.domainForAutoEmail = this.configurations.find(c => c.domain === this.settingsForm.get('domain').value);
      this.useDomainForAutoEmail.setValue(true);
      this.showDomainForAutoEmail = true;
    });
    // this.useDomainForAutoEmailValueChanges();
  }

  useDomainForAutoEmailValueChanges() {
    this.useDomainForAutoEmail.valueChanges.subscribe(value => (this.setDomainForAutoEmail = value));
  }

  addDomain() {
    this.emailInternalService.addInternalEmailDomain(this.settingsForm.get('domain').value, 'email').subscribe(configuration => {
      this.domainForAutoEmail = configuration;
      this.showDomainForAutoEmail = true;
    });
  }

  // useDomainForAutoEmailValueChanges() {
  //   this.settingsForm
  //     .get('domain')
  //     .valueChanges.pipe(debounceTime(2000))
  //     .subscribe(value => {
  //       if (this.configurations.length === 0) {
  //         this.emailInternalService.addInternalEmailDomain(this.settingsForm.get('domain').value, 'email').subscribe(configuration => {
  //           this.domainForAutoEmail = configuration;
  //         });
  //         return;
  //       }
  //       if (this.configurations.find(c => c.domain === this.settingsForm.get('domain').value)) {
  //         return;
  //       }

  //       this.emailInternalService.addInternalEmailDomain(this.settingsForm.get('domain').value, 'email').subscribe(configuration => {
  //         this.domainForAutoEmail = configuration;
  //       });
  //     });
  // }

  checkDomain() {
    if (!this.configurations.find(c => c.domain === this.settingsForm.get('domain').value)) {
      this.emailInternalService.addInternalEmailDomain(this.settingsForm.get('domain').value, 'email').subscribe(configuration => {
        this.domainForAutoEmail = configuration;
      });
    }
  }

  mountMsgType(msgType) {
    if (!this.msgTypes[msgType.id]) {
      this.msgTypesForm.push(
        this.formBuilder.group({
          label: msgType.label,
          id: msgType.id
        })
      );
      this.msgTypes[msgType.id] = msgType.label;
    }
  }

  get msgTypesForm() {
    return this.settingsForm.get('messageTypeLabels') as UntypedFormArray;
  }

  changeColor(ev, formcontrol) {
    this.settingsForm.controls[formcontrol].setValue(ev);
    this.settingsForm.markAsDirty();
  }

  submitActiveForm() {
    this.settingsForm.disable();
    const raw = SuperAccountSettings.deserialize(this.settingsForm.getRawValue());
    if (!this.settingsForm.get('logoBase64').value && !this.removeExistingLogo) {
      delete raw.logoBase64;
    }
    this.resellerService.editSuperAccountSettings(this.superAccountSettings, raw).subscribe(
      data => {
        this.atlasToast.success('common_success', null);
        if (this.setDomainForAutoEmail) {
          this.addDomain();
        } else {
          this.checkDomain();
        }
        this.superAccountSettings = data;
        this.settingsForm.patchValue(this.superAccountSettings);

        this.settingsForm.enable();
        this.settingsForm.markAsPristine();
        this.setDomainForAutoEmail = false;
      },
      () => {
        this.atlasToast.error('common_error', null);
        this.settingsForm.enable();
      },
      () => {}
    );
  }

  onLogoChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.settingsForm.get('logoBase64').setValue((reader.result as string).split(',')[1]);
        this.settingsForm.markAsDirty();
      };
    } else {
      this.settingsForm.get('logoBase64').setValue(null);
    }
  }

  openModalCNameDetails(): void {
    this.modalCNameDetailsModal = this.modalService.open(this.modalCNameDetails, { size: 'xl' });
    this.modalCNameDetailsModal.result.then(
      result => {
        this.modalService.dismissAll();
      },
      reason => {
        this.modalService.dismissAll();
      }
    );
  }

  resetForm() {
    this.settingsForm.reset(this.superAccountSettings);
  }

  private displayScrollIndicator() {
    if (!(this.$page && this.$actionsBar)) {
      return;
    }
    const $pageAccount: HTMLElement = this.$page.nativeElement;
    const $actionsBar: HTMLElement = this.$actionsBar.nativeElement;
    const $impersonateHeader: HTMLElement = document.getElementById('impersonate-header');

    if (!this.elRef.nativeElement || !this.elRef.nativeElement.closest('body')) {
      return;
    }

    const remainingHeight = window.innerHeight - $pageAccount.getBoundingClientRect().top;

    if (
      $pageAccount.clientHeight > remainingHeight + 5 &&
      $pageAccount.getBoundingClientRect().bottom - window.innerHeight - $impersonateHeader.getBoundingClientRect().bottom > 50
    ) {
      $actionsBar.classList.add('has--scroll-indicator');
    } else {
      $actionsBar.classList.remove('has--scroll-indicator');
    }
  }
}
